import { render } from "./PriceField.vue?vue&type=template&id=7216f10b&scoped=true"
import script from "./PriceField.vue?vue&type=script&lang=js"
export * from "./PriceField.vue?vue&type=script&lang=js"

import "./PriceField.vue?vue&type=style&index=0&id=7216f10b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7216f10b"

export default script